/* eslint-disable react-hooks/exhaustive-deps */
import { fetchPhpEigth } from "api";
import Piepagina from "components/Layout/FooterHomePublica";
import {
  urlCatalogoInicial,
  urlGuardarGarantia,
  urlMunicipios,
  urlObtenerEstados,
  urlTiendas,
} from "constants/urls_garantia";
import useCustomToast from "hooks/useCustomToasts";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { getQueryParams } from "utils/funciones";
import Loading from "wrappers/Loading";
import Form from "./components/Form";
import InfoGarantia from "./components/InfoGarantia";
import Navbar from "./components/Navbar";
import SeleccionarTienda from "./components/SeleccionarTienda";
import Steps from "./components/Steps/index";
import SuccessModal from "./components/SuccessModal";
import UploadFile from "./components/UploadFile";
import { TIPOS_QR } from "./enums";
import "./styles.scss";

const GarantiaEntendidaPage = () => {
  const methods = useForm({ mode: "onChange" });
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { addWarningToast } = useCustomToast();

  const [loadingEstados, setLoadingEstados] = useState(false);
  const [estados, setEstados] = useState([]);

  const [loadingMunicipios, setLoadingMunicipios] = useState(false);
  const [municipios, setMunicipios] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const [loadingTiendas, setLoadingTiendas] = useState(false);
  const [tiendas, setTiendas] = useState([]);

  const isQrGeneral = useMemo(() => data?.meta?.tipoQR === TIPOS_QR.GENERAL, [data]);

  const isQrTienda = useMemo(() => data?.meta?.tipoQR === TIPOS_QR.TIENDA, [data]);

  const canal = useWatch({
    name: "canal",
    control: methods.control,
  });

  const loadData = (formData) => {
    methods.reset(formData);
    if (formData.marcaManual) {
      setTimeout(() => {
        methods.setValue("marcaManual", formData.marcaManual, { shouldValidate: true });
      }, 50);
    }
  };
  const init = useCallback(async () => {
    setLoading(true);

    const qParams = getQueryParams();

    const res = await fetchPhpEigth(urlCatalogoInicial, qParams);
    const qCanal = qParams?.canal || "";
    loadData(res?.precarga);
    // loadData(testData);
    if (res.transaccion) {
      setData(res);
      if (qCanal !== "") {
        buscarEstados();
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  /**
   *
   * @param {Date} date
   */
  const formatDate = (date) => {
    const mes = date.getMonth() + 1;
    const mesStr = mes < 10 ? `0${mes}` : mes;

    const dia = date.getDate();
    console.log("DIA: ", dia);
    const diaStr = dia < 10 ? `0${dia}` : dia;

    const anio = date.getFullYear();

    return `${diaStr}-${mesStr}-${anio}`;
  };

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const body = {
        ...formData,
        estado: formData.estado?.label,
        municipio: formData.municipio?.label,
        fechaCompra: formatDate(formData.fechaCompra),
        fechaGarantia: formatDate(formData.fechaGarantia),
      };

      console.log(JSON.stringify(body));

      const res = await fetchPhpEigth(urlGuardarGarantia, body);
      console.log("RES: ", res);
      if (res?.transaccion) {
        setShowModal(true);
        methods.reset({});
        setLoading(false);
        return;
      } else if (res?.transaccion === false && res?.error?.errorDescripcion) {
        addWarningToast(res?.error?.errorDescripcion);
      }
    } catch (error) {
      addWarningToast("Ha ocurrido un problema al intentar guardar la información");
    }
    setLoading(false);
    loadData(formData);
  };

  const onHideModal = () => setShowModal(false);

  const resetTienda = useCallback(() => {
    methods.setValue("tiendaObj", null);
    methods.setValue("tienda.numero", "");
    methods.setValue("tienda.nombre", "");
    methods.setValue("tienda.direccion", "");
    setTiendas([]);
  }, []);

  const onChangeEstado = useCallback(async (evt) => {
    setLoadingMunicipios(true);
    methods.setValue("municipio", null);
    setMunicipios([]);
    resetTienda();
    const res = await fetchPhpEigth(urlMunicipios, {
      estado: evt.value,
      codCanal: getCanal(),
    });
    console.log(res);
    setMunicipios(res?.municipios);
    setLoadingMunicipios(false);
  }, []);

  const onChangeMunicipio = useCallback(async (evt) => {
    setLoadingTiendas(true);
    const estado = methods.watch("estado")?.value;
    resetTienda();
    const res = await fetchPhpEigth(urlTiendas, {
      estado: estado,
      municipio: evt.value,
      codCanal: getCanal(),
    });

    setTiendas(res?.tiendas);
    setLoadingTiendas(false);
  }, []);

  const getCanal = () => methods.watch("canal")?.value;

  const buscarEstados = useCallback(async () => {
    setLoadingEstados(true);
    const res = await fetchPhpEigth(urlObtenerEstados, {
      codCanal: getCanal(),
    });
    if (res?.transaccion && res?.estados) {
      setEstados(res?.estados);
    } else {
      addWarningToast("Ha ocurrido un problema al consultar los estados");
    }

    setLoadingEstados(false);
  }, []);

  const onChangeCanal = useCallback(async () => {
    try {
      methods.setValue("estado", null);
      methods.setValue("municipio", null);
      resetTienda();
      buscarEstados();
    } catch (error) {
      addWarningToast("Ha ocurridon un problema al consultar la información");
    }
  }, []);

  return (
    <FormProvider {...methods}>
      <Loading loading={loading}>
        {!loading && (
          <React.Fragment>
            <Navbar />
            <SeleccionarTienda
              canales={data?.canales}
              loading={loading || loadingEstados}
              buscarFecha={onChangeCanal}
              isQrTienda={isQrTienda}
              {...data?.textos?.seleccionTienda}
            />

            {canal && (
              <React.Fragment>
                <InfoGarantia {...data?.textos?.queEsGarantia} />
                <Steps steps={data?.pasos} />
                <div className='text-center pb-5'>
                  <h1 className='text-primary font-futura-bold' style={{ fontSize: "40px" }}>
                    ¡Comencemos!
                  </h1>
                  <p className='text-primary font-futura-medium' style={{ fontSize: "24px" }}>
                    Por favor ingresa la siguiente información
                  </p>

                  <img src={canal?.image} loading='lazy' className='img-fluid' alt='' />

                  <h1 className='font-futura-medium text-primary mb-5' style={{ fontSize: "24px" }}>
                    ¡Por favor completa este formulario para obtener tu Garantía Extendida!
                  </h1>
                </div>

                <Form
                  loadingEstados={loadingEstados}
                  estados={estados}
                  marcas={data?.marcas}
                  municipios={municipios}
                  onChangeEstado={onChangeEstado}
                  loadingMunicipios={loadingMunicipios}
                  tiendas={tiendas}
                  onChangeMunicipio={onChangeMunicipio}
                  loadingTiendas={loadingTiendas}
                  isQrGeneral={isQrGeneral}
                  isQrTienda={isQrTienda}
                />
                <UploadFile onSubmit={onSubmit} />
              </React.Fragment>
            )}

            <Piepagina />
          </React.Fragment>
        )}
      </Loading>
      <SuccessModal onHideModal={onHideModal} showModal={showModal} />
    </FormProvider>
  );
};

export default GarantiaEntendidaPage;
